export default __webpack_public_path__ + "locales/az/DataReassignmentDialog.json?hash=ade1575a6c489feecbf16908bed820cd";